import clsx from 'clsx'
import React, { FC, useContext } from 'react'

import { CheckoutFlowOrderSummary } from '@Domains/CheckoutV2/Features/CheckoutSteps/Components/CheckoutFlowOrderSummary/CheckoutFlowOrderSummary'
import { CheckoutFlowContext } from '@Domains/CheckoutV2/Features/CheckoutSteps/Contexts/CheckoutFlowContext'
import { CheckoutFlowPageStepList, CheckoutFlowSteps } from '@Domains/CheckoutV2/Features/CheckoutSteps/Contexts/typings/CheckoutFlowTypes'
import { CheckoutAddressStep } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutAddressStep/CheckoutAddressStep'
import { CheckoutAddressStepV2 } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutAddressStep/CheckoutAddressStepV2'
import { CheckoutPaymentStep } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/CheckoutPaymentStep'
import { CheckoutShippingStep } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutShippingStep/CheckoutShippingStep'
import { Experiment } from '@Globals/SplitTests/Experiment'
import { BubbleNavigation } from '@Shared/Components/Navigation/Buble/BubbleNavigation'

import styles from './CheckoutFlow.module.scss'

export interface CheckoutFlowProps {
}

export const CheckoutFlow: FC<CheckoutFlowProps> = () => {
  const { activeStep, data: { cart }, setActiveStep, stepValidations } = useContext(CheckoutFlowContext)

  return (
    <div className={styles.checkoutFlow}>
      <BubbleNavigation
        activeStep={activeStep}
        className={styles.stepper}
        onClick={setActiveStep}
        stepValidations={stepValidations}
        steps={CheckoutFlowPageStepList}
      />
      <section className={clsx(activeStep !== CheckoutFlowSteps.ADDRESS && styles.hidden)}>
        <Experiment
          a={(
            <CheckoutAddressStep>
              <CheckoutFlowOrderSummary
                expectedDelivery={cart.expectedDelivery || undefined}
                lineItemGroups={cart.lineItemGroups}
                lineItems={cart.lineItems || []}
                totals={cart.totals || []}
              />
            </CheckoutAddressStep>
          )}
          b={(
            <CheckoutAddressStepV2>
              <CheckoutFlowOrderSummary
                expectedDelivery={cart.expectedDelivery || undefined}
                lineItemGroups={cart.lineItemGroups}
                lineItems={cart.lineItems || []}
                totals={cart.totals || []}
              />
            </CheckoutAddressStepV2>
          )}
          test="checkout_save_address_once_v1"
        />

      </section>
      <section className={clsx(activeStep !== CheckoutFlowSteps.SHIPPING && styles.hidden)}>
        <CheckoutFlowOrderSummary
          expectedDelivery={cart.expectedDelivery || undefined}
          lineItemGroups={cart.lineItemGroups}
          lineItems={cart.lineItems || []}
          totals={cart.totals || []}
        />
        <CheckoutShippingStep />
        <CheckoutPaymentStep />
      </section>
    </div>
  )
}

